import * as constants from "./constants";
import {getInfoList,addInfoOne,delInfoOne} from '../../../api/commonInfo/index'
import { message } from "antd";
import { placeId } from "../../../utils/config";
import { getList } from '../../../api/cultrueName/index'
//上传页面显示
export const uploadingshow = () => ({
  type: constants.UPLOADING_SHOW
});
//上传页面隐藏
export const uploadinghide = () => ({
  type: constants.UPLOADING_HIDE
});
//编辑页面显示
export const compileshow = () => ({
  type: constants.COMPILE_SHOW
});
//编辑页面隐藏
export const compilehide = () => ({
  type: constants.COMPILE_HIDE
});
// 添加地名文化
export const addCultrueNameShow = () =>({
  type: constants.ADDCULTURE_SHOW 
})
// 隐藏地名文化
export const cultrueNameHide = () =>({
  type: constants.ADDCULTURE_HIDE
})


//获取表格内容的总数
const setcount = count => ({
  type: constants.SET_COUNT,
  count
});
//获取表格内容
const setlist = list => ({
  type: constants.SET_LIST,
  list
});

//重置current
const refreshCurrent = (current) => ({
  type: constants.REFRESH_CURRENT,
  current
});
//搜索框内容
const values = value => ({
  type: constants.VALUES,
  values: value
});
//设置current
const currents = index => ({
  type: constants.CURRENTS,
  current: index
});
//设置content
const content = record => ({
  type: constants.CONTENT,
  content: record
});
// 获取地名文化列表
const getCultrueNameList = cultrueNameList =>({
  type:constants.CULTRUENAME_LIST,
  cultrueNameList:cultrueNameList
});
// 修改当前地名文化
const editCultrueName = item =>({
  type:constants.EDIT_CULTRUENAME,
  cultrueName:item,
  // console.log(this.cultrueName);
  
})


//公共请求
export const request = (informationTypeId,currentPage=1,values='') => {
  return async dispatch => {

    const data = {
      informationTypeId,
      placeId:placeId,
      currentPage,
      pageSize:10
    }
    if(values){
      data.name = values
    }
    const res = await getInfoList(data)
    const result = res.data || {}
    //------------------------
    for(let item of result.data.list){
      if(!item.key){
        item.key = item.informationId
      }
    }
    
    dispatch(setcount(result.count));
    dispatch(setlist(result.data.list));
  };
};



// 获取列表
export const cultrueNameRequest = () => {
  return async dispatch => {
    const res = await getList()
    const result = res.data || {}
    dispatch(getCultrueNameList(result.data));
  };
};

// 获取地名文化
export const getCultrueName = () =>{
  return dispatch => {
    dispatch(cultrueNameRequest())
  }
}

// 编辑地名文化
export const setCultrueName =(item) =>{
  return dispatch => {
    dispatch(editCultrueName(item))
    dispatch(addCultrueNameShow())
  }
}
// 隐藏当前地名文化弹窗
export const hideCultrueName = ()=>{
  return dispatch => {
    dispatch(editCultrueName({}))
    dispatch(cultrueNameHide())
  }
}
// 上传成功后关闭
export const closeCultrueName =()=>{
  return dispatch =>{
    dispatch(editCultrueName({}))
    dispatch(cultrueNameHide())
    dispatch(cultrueNameRequest())
  }

}
//请求表格内容
export const contentManagementload = (id,current) => {
  return dispatch => {
    dispatch(request(id,current))
    dispatch(refreshCurrent(1));
  };
};
//上传成功后重新请求表格内容
export const anewRequest = (id) => {
  return async dispatch => {
    await dispatch(request(id))
    message.success('添加成功')
    dispatch(uploadinghide());
    dispatch(refreshCurrent(1));
  };
};
//  更新成功后重新请求表格内容
export const setRequest = (id,current,value) => {
  return async dispatch => {
    await dispatch(request(id,current,value))
    message.success('修改成功')
    dispatch(compilehide());
    dispatch(refreshCurrent(1));
  };
};
//查询
export const inputsearch = (value, key) => {
  return async dispatch => {
    await dispatch(request(key,1,value))
    dispatch(values(value));
    dispatch(refreshCurrent(1));
  };
};
//当搜索框内容为空
export const searchchange = (value, key) => {
  return async dispatch => {
    await dispatch(request(key))
    dispatch(values());
    dispatch(refreshCurrent(1));
  };
};
//分页点击事件
export const paginationchange = (index, key, values) => {
  return async dispatch => {
    await dispatch(request(key,index,values))
    dispatch(currents(index));
  };
};
//删除
export const removepupopok = (value, key, current) => {
  return  async dispatch => {
    console.log(value, key, current);
    const data = {
      informationTypeId:value.informationTypeId,
      informationId:value.informationId
    }
    await delInfoOne(data)
    await dispatch(request(value.informationTypeId,current))
    message.success('删除成功')
    dispatch(currents(current));
  };
};
//打开修改框 并获取当前点击行的内容
export const compile = record => {
  return dispatch => {
    dispatch(compileshow());
    dispatch(content(record));
  };
};
//上传成功后 关闭修改框，同时重新请求表格内容
export const compilesuccess = (key, index) => {
  return dispatch => {
    
  };
};
export const tabsonchange = (e, eventKey,id) => {
  return dispatch => {
    if(eventKey === '6_9'){
      // 地名文化
      // sessionStorage.setItem("tabskey", e);
      dispatch(request(id));
    }
    else if(eventKey === '6_10'){
      // 北麓岛
      // sessionStorage.setItem("tabskey1", e);
      dispatch(request(id));
    }
    else if(eventKey === '6_12'){
      // 北麓岛
      // sessionStorage.setItem("tabskey1", e);
      dispatch(request(id));
    }
    else if(eventKey === '6_13'){
      // 北麓岛
      // sessionStorage.setItem("tabskey1", e);
      dispatch(request(id));
    }
    else if(eventKey === '6_14'){
      // 北麓岛
      // sessionStorage.setItem("tabskey1", e);
      dispatch(request(id));
    }
    dispatch(refreshCurrent(1));
  };
};
